import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../assets/img/icons/up-down-aroow.svg'
import _imports_1 from '../../../assets/img/icons/eye.svg'
import _imports_2 from '../../../assets/img/icons/edit.svg'
import _imports_3 from '../../../assets/img/icons/close.svg'
import _imports_4 from '../../../assets/img/icons/left-arrow-purple.svg'
import _imports_5 from '../../../assets/img/icons/right-arrow-purple.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "table-responsive style-three" }
const _hoisted_4 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_5 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ps-0"
}
const _hoisted_6 = { class: "form-check checkbox" }
const _hoisted_7 = {
  class: "form-check-label",
  for: "test_1"
}
const _hoisted_8 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 pe-0"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  colspan: "7",
  class: "text-center py-4"
}
const _hoisted_16 = { class: "shadow-none fw-normal text-black title ps-0" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "form-check checkbox style-three" }
const _hoisted_19 = ["id"]
const _hoisted_20 = ["for"]
const _hoisted_21 = { class: "text-optional fs-14 ms-2" }
const _hoisted_22 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_23 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_24 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_25 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_26 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_27 = { class: "shadow-none lh-1 text-end pe-0" }
const _hoisted_28 = { class: "button-group d-flex flex-wrap align-items-center" }
const _hoisted_29 = ["title", "onClick"]
const _hoisted_30 = ["alt"]
const _hoisted_31 = ["alt"]
const _hoisted_32 = ["title", "onClick"]
const _hoisted_33 = ["alt"]
const _hoisted_34 = { class: "row pb-45 align-items-center" }
const _hoisted_35 = { class: "col-sm-6" }
const _hoisted_36 = { class: "d-flex flex-wrap align-items-center justify-content-center justify-content-sm-start page-unit" }
const _hoisted_37 = { class: "fs-13" }
const _hoisted_38 = { value: 10000 }
const _hoisted_39 = { class: "col-sm-6 text-sm-end text-center" }
const _hoisted_40 = { class: "page-nav list-style" }
const _hoisted_41 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[4] || (_cache[4] = _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "test_1"
                    }, null, -1)),
                    _createElementVNode("label", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.t("expense_page.date")) + " ", 1),
                      _cache[3] || (_cache[3] = _createElementVNode("img", {
                        class: "ms-2",
                        src: _imports_0,
                        alt: "Image"
                      }, null, -1))
                    ])
                  ])
                ]),
                _createElementVNode("th", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.t("expense_page.reference")) + " ", 1),
                  _cache[5] || (_cache[5] = _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1))
                ]),
                _createElementVNode("th", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.t("expense_page.warehouse")) + " ", 1),
                  _cache[6] || (_cache[6] = _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1))
                ]),
                _createElementVNode("th", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.t("expense_page.category")) + " ", 1),
                  _cache[7] || (_cache[7] = _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1))
                ]),
                _createElementVNode("th", _hoisted_11, [
                  _createTextVNode(_toDisplayString(_ctx.t("expense_page.amount")) + " ", 1),
                  _cache[8] || (_cache[8] = _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1))
                ]),
                _createElementVNode("th", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.t("expense_page.details")) + " ", 1),
                  _cache[9] || (_cache[9] = _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1))
                ]),
                _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.t("expense_page.action")), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.expenses.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.t("expense_page.no_expenses_found")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedExpenses, (expense) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: expense.id
                }, [
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: 'checkbox_' + expense.id
                        }, null, 8, _hoisted_19),
                        _createElementVNode("label", {
                          class: "form-check-label text-optional",
                          for: 'checkbox_' + expense.id
                        }, null, 8, _hoisted_20)
                      ]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formatDateTime(expense.date)), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(expense.referenceno), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(expense.warehouse?.name || _ctx.t("expense_page.not_available")), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(expense.category?.name || expense.category_name || _ctx.t("expense_page.not_available")), 1),
                  _createElementVNode("td", _hoisted_25, " $" + _toDisplayString(Number(expense.amount).toFixed(2)), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(expense.description || _ctx.t("expense_page.no_description")), 1),
                  _createElementVNode("td", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        title: _ctx.t('expense_page.view'),
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#detailsModal",
                        onClick: ($event: any) => (_ctx.viewDetails(expense))
                      }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: _ctx.t('expense_page.view')
                        }, null, 8, _hoisted_30)
                      ], 8, _hoisted_29),
                      _createVNode(_component_router_link, {
                        to: `/edit-expense/${expense.id}`,
                        title: _ctx.t('expense_page.edit')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _imports_2,
                            alt: _ctx.t('expense_page.edit')
                          }, null, 8, _hoisted_31)
                        ]),
                        _: 1
                      }, 8, ["to", "title"]),
                      _createElementVNode("a", {
                        class: "delete-btn",
                        href: "javascript:void(0)",
                        title: _ctx.t('expense_page.delete'),
                        onClick: ($event: any) => (_ctx.confirmDelete(expense.id))
                      }, [
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: _ctx.t('expense_page.delete')
                        }, null, 8, _hoisted_33)
                      ], 8, _hoisted_32)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.t("expense_page.showing_expense_per_page")), 1),
          _withDirectives(_createElementVNode("select", {
            class: "text-title border-0 fs-14 bg-transparent",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemsPerPage) = $event))
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("option", { value: 5 }, "5", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("option", { value: 10 }, "10", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("option", { value: 20 }, "20", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("option", { value: 50 }, "50", -1)),
            _createElementVNode("option", _hoisted_38, _toDisplayString(_ctx.t("common.all")), 1)
          ], 512), [
            [_vModelSelect, _ctx.itemsPerPage]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("ul", _hoisted_40, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
              class: _normalizeClass({ disabled: _ctx.currentPage === 1 })
            }, [...(_cache[14] || (_cache[14] = [
              _createElementVNode("img", {
                src: _imports_4,
                alt: "Image"
              }, null, -1)
            ]))], 2)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
            return (_openBlock(), _createElementBlock("li", { key: page }, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                class: _normalizeClass({ active: _ctx.currentPage === page }),
                onClick: ($event: any) => (_ctx.goToPage(page))
              }, _toDisplayString(page), 11, _hoisted_41)
            ]))
          }), 128)),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
              class: _normalizeClass({ disabled: _ctx.currentPage === _ctx.totalPages })
            }, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("img", {
                src: _imports_5,
                alt: "Image"
              }, null, -1)
            ]))], 2)
          ])
        ])
      ])
    ])
  ], 64))
}